"use strict";

module.exports = function isNumber(_int) {
  return Number.isFinite(_int);
};